import { InfluxCheatSheet } from './InfluxCheatSheet';

export function InfluxStartPage() {
  return <InfluxCheatSheet />;
}
